export default __webpack_public_path__ + "static/media/codesandbox-icon.7d2a4cef.svg";